import { Box } from '@mui/material';
import { useContext } from 'react';
import { SlidePreviewContext } from '../../lessons/contexts/SlidePreviewContext';
import { SlideComponent, SlideComponentSasAudio } from 'models/lesson/LessonModel';

export const SlideSasAudio = ({ item }: { item: SlideComponent; index: number }) => {
    const { zoom } = useContext(SlidePreviewContext);

    let itemContent: SlideComponentSasAudio = item.content as SlideComponentSasAudio;

    // console.log(item.pos.x * zoom, item.pos.y * zoom);

    return (
        <Box
            component='img'
            src={
                itemContent.questionImageURL && itemContent.questionImageURL !== ''
                    ? itemContent.questionImageURL
                    : `/characters/${itemContent.questionImage !== '' ? itemContent.questionImage + '/image.png' : 'default.png'}`
            }
            alt='bg'
            sx={{
                position: 'absolute',
                zoom: zoom,
                aspectRatio: 'auto',
                transform: `scaleX(${itemContent.questionImageFlip ?? 1})`,
                pointerEvents: 'none',
                left: item.pos.x,
                top: item.pos.y,
                zIndex: itemContent.zIndex,
                m: 'inherit',
                p: 'inherit',
            }}
            width={item.size.width}
        />
    );
};
